module.exports = __webpack_public_path__ + "static/img/deve7.cee8e93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/deve7.png
// module id = Y7M9
// module chunks = 1